import styled from "@emotion/styled";
import { GelButton, GelContainerLite } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import { useEffect, useState } from "react";

const PageNavbar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const calculateProgress = () => {
      const windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = windowScroll / height;
      setProgress(scrolled);
    };
    window.addEventListener("scroll", calculateProgress);
    return () => window.removeEventListener("scroll", calculateProgress);
  }, [progress]);

  return (
    <>
      <StyledStickyContainer id="navbar">
        <StyledNavbarContainer>
          <img
            alt="TAL Logo"
            src={process.env.PUBLIC_URL + "/images/logo.png"}
            height="56px"
            width="inherit"
          />
          {/* <GelButton
            primary
            medium
            onClick={() =>
              window.open(
                "https://www.tal.com.au/about-us/our-commitments/our-customers/health/tal-spotchecker/book-a-skin-check",
                "_blank"
              )
            }
          >
            Book a skin check
          </GelButton> */}
        </StyledNavbarContainer>
      </StyledStickyContainer>
    </>
  );
};

export default PageNavbar;

const StyledNavbarContainer = styled(GelContainerLite)(
  {
    backgroundColor: getGelTokens().global.themeColorBackgroundDefault,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: getGelTokens().global.elevationMd,
    borderBottom: `1px solid ${getGelTokens().global.themeColorBorderDefault}`,
  },

  (props) => ({
    height: props.height ? props.height : 56,
  })
);

const StyledStickyContainer = styled.div`
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  left: 0;
  z-index: 99;
`;
